import { createContext, useContext, useState } from "react";
import * as API from '../services/API';
const AuthContext = createContext<AuthContextType>(null!);

interface AuthContextType {
    cpf: string;
    pass: string;
    token: string;
    profile: any;
    signin: (cpf: string, password: string, callback: VoidFunction) => void;
    signout: (callback: VoidFunction) => void;
    getBalance: () => any;
}

function AuthProvider({ children }: { children: React.ReactNode }) {
    const [cpf, setCPF] = useState<string>('')
    const [pass, setPass] = useState<string>('')
    const [token, setToken] = useState<string>('')
    const [profile, setProfile] = useState<any>()
    const [balance, setBalance] = useState<string>('--')
    const signin = async (cpf: string, pass: string, callback: VoidFunction) => {
        setCPF(cpf)
        setPass(pass)
        try {
            const token = await API.login(cpf, pass)
            setToken(token)
            const user = await API.getProfile(cpf, token)
            if (user)
                setProfile(user)
            callback()
        } catch (error) {
            console.error('Erro:', error)
        }
    }
    const signout = () => {

    }
    const getBalance = async () => {
        try {
            const value = await API.getBalance(token)
            setBalance(value.toString())
            return value
        }
        catch (error) {
            console.error('Erro ao obter saldo:', error)
        }
        return balance
    }
    let value: AuthContextType = { cpf, pass, token, profile, signin, signout, getBalance };
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => {
    return useContext(AuthContext)
}

export default AuthProvider;